import { createRangeModule, type RangeSlice } from "../utils/createRangeModule";

/** @deprecated Use RangeSlice instead */
export type EmployeesSlice = RangeSlice;

export const employeesModule = createRangeModule({
  key: "employees",
  apiField: "employees",
  apiFixedField: "hasFixedEmployees",
  checkboxLabel:
    "Limit to companies with fixed employee values within this range",
  chipLabel: "Employees",
  isCurrency: false,
});

export const defaultEmployeesSlice = employeesModule.defaultSlice;
